import { Component, type ErrorInfo, type ReactNode } from 'react';
import styles from './index.module.scss';

type TProps = {
  children: ReactNode;
  id: string;
};

type TState = {
  hasError: boolean;
};

export default class NoteErrorBoundary extends Component<TProps, TState> {
  public override state: TState = {
    hasError: false,
  };

  public static getDerivedStateFromError (): TState {
    return { hasError: true };
  }

  public override componentDidCatch (error: Error, errorInfo: ErrorInfo): void {
    console.error(`Note #${this.props.id} render error`, error, errorInfo);
  }

  public override render () {
    if (this.state.hasError) {
      return <div className={styles['note-error-boundary']}>Wystąpił błąd podczas ładowania notki. Spróbuj ponownie za chwilę...</div>;
    }

    return this.props.children;
  }
}
